import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'
// import globalAttentionIndexJson from './../testsupport/apiresults/GlobalAttentionIndex.json'

export const DefaultGlobalAttentionIndexState = {
    selectedDate: null,
    selectedView: null,
    anticipationViewDetails: {}
}

export const anticipationViewDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultState,
  actionRequest: ActionTypes.REQUEST_ANTICIPATION_INDEX,
  actionReceive: ActionTypes.RECEIVE_ANTICIPATION_INDEX,
  actionFailure: ActionTypes.REQUEST_ANTICIPATION_INDEX_FAILURE
})

export const topContentViewDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultState,
  actionRequest: ActionTypes.REQUEST_TOP_CONTENT_INDEX,
  actionReceive: ActionTypes.RECEIVE_TOP_CONTENT_INDEX,
  actionFailure: ActionTypes.REQUEST_TOP_CONTENT_INDEX_FAILURE
})

export const trendingViewDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultState,
  actionRequest: ActionTypes.REQUEST_TRENDING_INDEX,
  actionReceive: ActionTypes.RECEIVE_TRENDING_INDEX,
  actionFailure: ActionTypes.REQUEST_TRENDING_INDEX_FAILURE
})

export const cancelledShowsDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultState,
  actionRequest: ActionTypes.REQUEST_CANCELLED_SHOWS_INDEX,
  actionReceive: ActionTypes.RECEIVE_CANCELLED_SHOWS_INDEX,
  actionFailure: ActionTypes.REQUEST_CANCELLED_SHOWS_INDEX_FAILURE
})

export const globalAttentionIndexByDate = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_ANTICIPATION_INDEX:
    case ActionTypes.RECEIVE_ANTICIPATION_INDEX:
      if (action.startDate && action.endDate) {
        return {
          ...state.anticipationViewDetails,
          [action.startDate+'_'+action.endDate]: anticipationViewDetails(state.details, action)
        }
      } else {
        console.warn('Anticipation Index action fired without a startDate/endDate:', action)
        return state
      }
    case ActionTypes.REQUEST_TOP_CONTENT_INDEX:
    case ActionTypes.RECEIVE_TOP_CONTENT_INDEX:
      if (action.startDate && action.endDate) {
        return {
          ...state.topContentViewDetails,
          [action.startDate+'_'+action.endDate]: topContentViewDetails(state.details, action)
        }
      } else {
        console.warn('Top Content Index action fired without a startDate/endDate:', action)
        return state
      }
    case ActionTypes.REQUEST_TRENDING_INDEX:
    case ActionTypes.RECEIVE_TRENDING_INDEX:
      if (action.startDate && action.endDate) {
        return {
          ...state.trendingViewDetails,
          [action.startDate+'_'+action.endDate]: trendingViewDetails(state.details, action)
        }
      } else {
        console.warn('Trending Index action fired without a startDate/endDate:', action)
        return state
      }
    case ActionTypes.REQUEST_CANCELLED_SHOWS_INDEX:
    case ActionTypes.RECEIVE_CANCELLED_SHOWS_INDEX:
      if (action.startDate && action.endDate) {
        return {
          ...state.trendingViewDetails,
          [action.startDate+'_'+action.endDate]: cancelledShowsDetails(state.details, action)
        }
      } else {
        console.warn('Cancelled Shows Index action fired without a startDate/endDate:', action)
        return state
      }
    default:
      return state
    }
}

export const globalAttentionIndex = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.SELECTED_ATTENTION_INDEX_DATE:
      return {
        ...state,
        selectedDate: action.date
      }
    case ActionTypes.SELECTED_ATTENTION_INDEX_VIEW:
      return {
        ...state,
        selectedView: action.view
      }
    case ActionTypes.REQUEST_ANTICIPATION_INDEX:
    case ActionTypes.RECEIVE_ANTICIPATION_INDEX:
      return {
        ...state,
        anticipationViewDetails: globalAttentionIndexByDate(state, action)
      }
    case ActionTypes.REQUEST_TOP_CONTENT_INDEX:
    case ActionTypes.RECEIVE_TOP_CONTENT_INDEX:
      return {
        ...state,
        topContentViewDetails: globalAttentionIndexByDate(state, action)
      }
    case ActionTypes.REQUEST_TRENDING_INDEX:
    case ActionTypes.RECEIVE_TRENDING_INDEX:
      return {
        ...state,
        trendingViewDetails: globalAttentionIndexByDate(state, action)
      }
    case ActionTypes.REQUEST_CANCELLED_SHOWS_INDEX:
    case ActionTypes.RECEIVE_CANCELLED_SHOWS_INDEX:
      return {
        ...state,
        cancelledShowsDetails: globalAttentionIndexByDate(state, action)
      }
    default:
      return state
    }
}